import { Typography } from "@material-ui/core";
import { MenuItemLink, UserMenu } from "react-admin";
import AccountCircle from "@material-ui/icons/AccountCircle";

import useCurrentUser from "../../hooks/useCurrentUser";
import { AppResource } from "../../types/resource.types";
import useIsAdmin from "../../hooks/useIsAdmin";
import colors from "../../theme/colors";

const MyUserMenu = (props: any) => {
  const { user } = useCurrentUser();
  const { isAdmin } = useIsAdmin();

  return (
    <UserMenu {...props}>
      <Typography color="textSecondary" variant="body2" style={{ padding: 16 }}>
        {user.email}
      </Typography>
      {!isAdmin && (
        <MenuItemLink
          style={{ color: colors.primary.main }}
          to={`/${AppResource.profile}`}
          leftIcon={<AccountCircle style={{ color: colors.primary.main }} />}
          primaryText={"Profile"}
        />
      )}
    </UserMenu>
  );
};

export default MyUserMenu;
